/**
 * Client-side phone number formatting (mirrors backend normalizer).
 * Used for display and input formatting.
 */

export function formatPhone(phone) {
  if (!phone) return '';
  return phone; // Already normalized by backend - just display as-is
}

export function normalizePhoneInput(value) {
  // Strip everything except digits for live input
  const digits = value.replace(/\D/g, '');

  if (digits.length === 0) return '';

  // Mobile: 050-xxx-xxxx (10 digits)
  if (digits.length <= 10 && digits.startsWith('0') && digits[1] !== '2' && digits[1] !== '3' && digits[1] !== '4' && digits[1] !== '8' && digits[1] !== '9') {
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }

  // Landline: 0x-xxx-xxxx (9 digits)
  if (digits.length <= 9 && digits.startsWith('0')) {
    if (digits.length <= 2) return digits;
    if (digits.length <= 5) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    return `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5, 9)}`;
  }

  return digits;
}

export function isValidIsraeliPhone(phone) {
  if (!phone) return false;
  const digits = phone.replace(/\D/g, '');
  if (digits.startsWith('972')) return digits.length >= 12;
  if (digits.startsWith('0')) return digits.length === 9 || digits.length === 10;
  return false;
}
